import { gql } from "@apollo/client";
import { ApiRoutes } from "../common/variables/apiRoutes";

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($input: UpdateEventInput!) {
    putEvent(input: $input)
      @rest(
        path: "${ApiRoutes.UpdateEventDetails}"
        method: "PUT"
        type: "UpdateEventResponse"
        bodyKey: "input"
      ) {
      message
      path
      data
      timestamp
    }
  }
`;

export const UPDATE_EVENT_FEEDBACK = gql`
  mutation UpdateEventFeedback($input: UpdateEventFeedbackInput!) {
    updateEventFeedback(input: $input)
      @rest(
        method: "PUT"
        type: "UpdateEventResponse"
        path: "${ApiRoutes.UpdateEventFeedback}"
        bodyKey: "input"
      ) {
      message
      path
      data
      timestamp
    }
  }
`;
